import { ARC_ENVIRONMENT } from './arc-env';
const arns = {
  dev: 'arn:aws:secretsmanager:us-east-2:061051221459:secret:arc-socketlabs-credentials-dev-S2LXtV',
  staging: 'arn:aws:secretsmanager:us-east-2:688567275412:secret:arc-socketlabs-credentials-staging-2NzPNg',
  prod: 'arn:aws:secretsmanager:us-east-2:054037137030:secret:arc-socketlabs-credentials-prod-73r8wj'
};
export const ARC_SOCKETLABS_CREDENTIALS_SECRET_ARN = arns[ARC_ENVIRONMENT];